import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import ImageTemplate from './ImageTemplate'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon

export default class ImageComponent extends Rete.Component {
  constructor (config) {
    super(CONST_COMPONENT.IMAGE)

    this.data.component = ImageTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
  }

  builder (node) {
    node.lingualName = lingualName.IMAGE
    this.setConnection()
    
    const imageInput = new Rete.Input(CONST_SOCKET.IMAGE_INPUT,  lang.image_socket_input_reply, this.socket.imageInput, true)
    const imageOutput = new Rete.Output(CONST_SOCKET.IMAGE_OUTPUT, lang.image_socket_output_next, this.socket.imageOutput, false)
    const imageOutputQuickreply = new Rete.Output(CONST_SOCKET.IMAGE_OUTPUT_QUICKREPLY, lang.image_socket_output_quick_replies, this.socket.imageOutputQuickreply, true)

    node.addInput(imageInput)
    node.addOutput(imageOutput)

    if (! instagram_addon) {
      node.addOutput(imageOutputQuickreply)
    }

    return node
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    outputs[CONST_SOCKET.IMAGE_OUTPUT] = node.data
  }
 
  setConnection() {
    // Image may take connections from:
    this.socket.imageInput.combineWith(this.socket.referenceOutput)
    this.socket.imageInput.combineWith(this.socket.newPostbackOutput)
    this.socket.imageInput.combineWith(this.socket.textOutput)
    this.socket.imageInput.combineWith(this.socket.carouselOutput)
    this.socket.imageInput.combineWith(this.socket.facebookMediaOutput)
    this.socket.imageInput.combineWith(this.socket.imageOutput)
    this.socket.imageInput.combineWith(this.socket.videoOutput)
    this.socket.imageInput.combineWith(this.socket.audioOutput)
    this.socket.imageInput.combineWith(this.socket.fileOutput)
    this.socket.imageInput.combineWith(this.socket.ecommerceOutput)
    this.socket.imageInput.combineWith(this.socket.genericTemplateOutput)
    this.socket.imageInput.combineWith(this.socket.otnOutput)

    // Image may be connected to:
    this.socket.imageOutput.combineWith(this.socket.textInput)
    this.socket.imageOutput.combineWith(this.socket.carouselInput)
    this.socket.imageOutput.combineWith(this.socket.facebookMediaInput)
    this.socket.imageOutput.combineWith(this.socket.imageInput)
    this.socket.imageOutput.combineWith(this.socket.videoInput)
    this.socket.imageOutput.combineWith(this.socket.audioInput)
    this.socket.imageOutput.combineWith(this.socket.fileInput)
    this.socket.imageOutput.combineWith(this.socket.ecommerceInput)
    this.socket.imageOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.imageOutput.combineWith(this.socket.otnInput)
    this.socket.imageOutput.combineWith(this.socket.componentListInput)

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.imageOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (QuickReply): QuickReply
    this.socket.imageOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }  
}